module.exports = __webpack_public_path__ + "static/media/custom-keyboard.afb4918e.svg";